import { useMemo } from 'react';
import toast from 'react-hot-toast';
import { ColumnGroup } from 'react-table';

import { ordersDataService } from 'services/orders.service';

import { Actions } from 'components/Actions';
import { Button } from 'components/Button';
import { Status } from 'components/Status';

export const useColumns = (restoreBtnClickSet: Function) => {
  // eslint-disable-next-line
  const handleButtonClick = async (row: any) => {
    if (row) {
      const { orderId, status } = row.original;
      if (status === 'DELETED') {
        try {
          await ordersDataService.restore(orderId);
          toast.success('restored');
        } catch {
          // Refused (e.g. not enough red/blue stock): the backend's message is already shown.
        }
        restoreBtnClickSet((prev: boolean) => !prev);
      } else {
        await ordersDataService.delete(orderId);
        restoreBtnClickSet((prev: boolean) => !prev);
        toast.success('deleted');
      }
    }
  };

  return useMemo(
    (): ColumnGroup[] => [
      {
        Header: 'Orders',
        columns: [
          {
            Header: 'Number',
            accessor: 'orderNumber',
          },
          {
            Header: 'Gender',
            accessor: 'genders',
            disableSortBy: true,
            Cell: ({ value }) => (
              <p>
                {value.map((v: string, idx: number) => (
                  <span key={v}>
                    {v}
                    {value.length > 0 && idx < value.length - 1 && ', '}
                  </span>
                ))}
              </p>
            ),
          },
          {
            Header: 'Catalog',
            accessor: 'catalogues',
            disableSortBy: true,
          },
          {
            Header: 'Customer Code',
            accessor: 'customerCode',
          },
          {
            Header: "Client's name",
            accessor: 'customerName',
            disableSortBy: true,
          },
          {
            Header: 'State',
            accessor: 'status',
            Cell: ({ value }) => <Status status={value} />,
          },
          {
            Header: 'Date of dispatch',
            accessor: 'date',
          },
          {
            Header: 'Eliminated',
            accessor: 'eliminated',
            disableSortBy: true,
            Cell: ({ value, row }) => (
              <Button
                motive="primaryBlack"
                iconLeft={value ? 'FiCheck' : 'FiX'}
                onClick={() => handleButtonClick(row)}
              >
                {value ? 'Restore' : 'Remove'}
              </Button>
            ),
          },
          {
            Header: 'Details',
            accessor: 'action',
            disableSortBy: true,
            Cell: ({ row }) => <Actions tableName="orders" isViewPath rowData={row} />,
          },
        ],
      },
    ],
    []
  );
};
